// Source: http://stackoverflow.com/questions/497790
var dates = {
    SSUX: {
        mon: true,
        tue: true,
        wed: true,
        thu: true,
        fri: true,
        sat: false,
        sun: false,
    },
    SO: {
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: true,
        sun: false,
    },
    SU: {
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false,
        sun: true,
    },
    SUX: {
        mon: true,
        tue: true,
        wed: true,
        thu: true,
        fri: true,
        sat: true,
        sun: false,
    },
    convert: d => {
        // Converts the date in d to a date-object. The input can be:
        //   a date object: returned without modification
        //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
        //   a number     : Interpreted as number of milliseconds
        //                  since 1 Jan 1970 (a timestamp) 
        //   a string     : Any format supported by the javascript engine, like
        //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
        //  an object     : Interpreted as an object with year, month and date
        //                  attributes.  **NOTE** month is 0-11.
        return (
            d.constructor === Date ? d :
            d.constructor === Array ? new Date(d[0],d[1],d[2]) :
            d.constructor === Number ? new Date(d) :
            d.constructor === String ? new Date(d) :
            typeof d === "object" ? new Date(d.year,d.month,d.date) :
            NaN
        )
    },
    compare: (a,b,_this) => {
        // Compare two dates (could be of any type supported by the convert
        // function above) and returns:
        //  -1 : if a < b
        //   0 : if a = b
        //   1 : if a > b
        // NaN : if a or b is an illegal date
        // NOTE: The code inside isFinite does an assignment (=).
        return (
            isFinite(a=_this.convert(a).valueOf()) &&
            isFinite(b=_this.convert(b).valueOf()) ?
            (a>b)-(a<b) :
            NaN
        )
    },
    inRange: (d,start,end) => {
        // Checks if date in d is between dates in start and end.
        // Returns a boolean or NaN:
        //    true  : if d is between start and end (inclusive)
        //    false : if d is before start or after end
        //    NaN   : if one or more of the dates is illegal.
        // NOTE: The code inside isFinite does an assignment (=).
       return (
            isFinite(d=this.convert(d).valueOf()) &&
            isFinite(start=this.convert(start).valueOf()) &&
            isFinite(end=this.convert(end).valueOf()) ?
            start <= d && d <= end :
            NaN
        )
    },
    days_words : {
        mon: 'Mondays',
        tue: 'Tuesdays',
        wed: 'Wednesdays',
        thu: 'Thursdays',
        fri: 'Fridays',
        sat: 'Saturdays',
        sun: 'Sundays',
    },
    getDayCode: day => {
        const days_codes = {
          mon: 'M',
          tue: 'T',
          wed: 'W',
          thu: 'Th',
          fri: 'F',
          sat: 'S',
          sun: 'SU',
        }
        return days_codes[day]
    },
    getDayWord: day => {
        const days_words = {
          mon: 'Mondays',
          tue: 'Tuesdays',
          wed: 'Wednesdays',
          thu: 'Thursdays',
          fri: 'Fridays',
          sat: 'Saturdays',
          sun: 'Sundays',
        }
        return days_words[day]
    },
    getCodes: (days, _this) => {
        let codes = ''
        for (var i = 0; i < days.length; i++) {
          codes+= _this.getDayCode(days[i])
        }
        return codes
    },
    getWords: (days, _this) => {
        return (
          days.length > 1 ?
            `${_this.getDayWord(days[0])} ${(days.length == 2 ? 'and' : 'to')} ${_this.getDayWord(days[days.length-1])}`
          :
            _this.getDayWord(days[0])
        )
    },
    checkDays: (days_run, _this) => {
        let days_run_ordered = {
          mon: false,
          tue: false,
          wed: false,
          thu: false,
          fri: false,
          sat: false,
          sun: false,
        }
        let days_w = [
          'mon',
          'tue',
          'wed',
          'thu',
          'fri',
          'sat',
          'sun',
        ]
        for (var i = days_w.length - 1; i >= 0; i--) {
          days_run_ordered[days_w[i]] = days_run[days_w[i]]
        }
        let contains = Object.keys(days_run_ordered).filter((key)=>(days_run_ordered[key]))
        let excludes = Object.keys(days_run_ordered).filter((key)=>(!days_run_ordered[key]))
        let codes = (contains.length < excludes.length ? _this.getCodes(contains,_this) : _this.getCodes(excludes,_this))
        // return `${_this.getWords(contains, _this)} (${codes}${(contains.length < excludes.length ? 'O':'X')})`
        return `${codes}${(contains.length < excludes.length ? 'O':'X')}`
    },
    checkDaysSemantic: (days_run, _this) => {
        let days_run_ordered = {
          mon: false,
          tue: false,
          wed: false,
          thu: false,
          fri: false,
          sat: false,
          sun: false,
        }
        let days_w = [
          'mon',
          'tue',
          'wed',
          'thu',
          'fri',
          'sat',
          'sun',
        ]
        for (var i = days_w.length - 1; i >= 0; i--) {
          days_run_ordered[days_w[i]] = days_run[days_w[i]]
        }
        let contains = Object.keys(days_run_ordered).filter((key)=>(days_run_ordered[key]))
        let excludes = Object.keys(days_run_ordered).filter((key)=>(!days_run_ordered[key]))
        return `${_this.getWords(contains, _this)}`
    }
}

export default dates


// WEBPACK FOOTER //
// ./src/helpers/dates.js